<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    persistent
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-card>
      <v-toolbar color="primary" dark flat short class="px-2">
        <v-toolbar-title>Preset Surface Decoration</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="cancel()" icon><v-icon>fas fa-times</v-icon></v-btn>
      </v-toolbar>

      <v-card-text class="mt-12">
        <v-form @submit.prevent>

            <v-autocomplete
              v-if="!model.id"
              outlined
              clearable
              clear-icon="fas fa-times"
              class="mb-2"
              v-model="model.decoration_ids"
              :error-messages="errors.decoration_id"
              item-text="description"
              item-value="id"
              :items="decorations"
              label="Decorations"
              multiple
              chips
            ></v-autocomplete>

            <v-autocomplete
              v-else
              outlined
              clearable
              clear-icon="fas fa-times"
              class="mb-2"
              v-model="model.decoration_id"
              :error-messages="errors.decoration_id"
              item-text="description"
              item-value="id"
              :items="decorations"
              label="Decoration"
            ></v-autocomplete>

            <v-autocomplete
              outlined
              clearable
              clear-icon="fas fa-times"
              class="mb-2"
              v-model="model.surface_id"
              :error-messages="errors.surface_id"
              item-text="description"
              item-value="id"
              :items="surfaces"
              label="Surface"
            ></v-autocomplete>

            <v-autocomplete
              outlined
              clearable
              clear-icon="fas fa-times"
              class="mb-2"
              v-model="model.excludes"
              :error-messages="errors.excludes"
              item-text="description"
              item-value="id"
              :items="surfaces"
              label="Excludes"
              multiple
              chips
            ></v-autocomplete>

            <v-autocomplete
              outlined
              clearable
              clear-icon="fas fa-times"
              class="mb-2"
              v-model="model.requires"
              :error-messages="errors.requires"
              item-text="description"
              item-value="id"
              :items="surfaces"
              label="Requires"
              hint="This surface can only be selected when all required surfaces are selected too"
              persistent-hint
              multiple
              chips
            ></v-autocomplete>

        </v-form>
      </v-card-text>

      <v-card-actions class="px-6 pb-8">
        <v-btn
          v-if="model.id"
          color="error"
          class=""
          large
          outlined
          depressed
          @click="$refs.deleteItemConfirmDialog.show()"
          :disabled="!user.can('preset-surface-decoration.delete')"
        >Delete</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="px-5"
          large
          outlined
          depressed
          @click="cancel()"
        >Cancel</v-btn>
        <v-btn
          color="primary"
          class="px-5"
          large
          depressed
          @click="save()"
        >Save</v-btn>
      </v-card-actions>

      <ConfirmDialog
        ref="deleteItemConfirmDialog"
        @confirm="deleteItem()"
        title="Confirm"
        message="Preset Surface Decoration will be deleted. Are you sure?"
        labelConfirm="OK"
        labelCancel="Cancel"
      ></ConfirmDialog>


    </v-card>

  </v-dialog>
</template>

<script>
import { ref, watch, inject } from 'vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    value: Boolean,
    model: Object,
    errors: Object,
    decorations: Array,
    surfaces: Array,
  },
  setup(props, context) {
    const api = inject('api')
    const { user } = api
    const dialog = ref(false)

    watch(() => props.value, val => {
      dialog.value = val
    })

    watch(dialog, val => {
      context.emit('input', val)
    })

    function save() {
      context.emit('save')
    }

    function cancel() {
      dialog.value = false
      context.emit('cancel')
    }

    function show() {
      dialog.value = true
    }

    function hide() {
      dialog.value = false
    }

    function deleteItem() {
      context.emit('delete', props.model)
    }



    return {
      user,
      dialog,

      save,
      cancel,

      show,
      hide,
      deleteItem,
    }
  }}
</script>